export const EXTEND_FREE_LICENSE = "extend_free_license";
export const EXTEND_FREE_LICENSE_SUCCESSFUL = "extend_free_license_successful";
export const EXTEND_FREE_LICENSE_FAILED = "extend_free_license_failed";

export const CLEAR_ALL_FREE_LICENSE_MESSAGES = "clear_all_free_license_messages";
export const CLEAR_ALL_FREE_LICENSE_MESSAGES_SUCCESSFUL = "clear_all_free_license_messages_successful";

